import { createSlice } from "@reduxjs/toolkit";

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    all: [],
    byId: [],
    isLoading: true,
    item: {
      all: [],
      byId: [],
      isLoading: true,
    },
  },
  reducers: {
    load: (state, action) => {
      state.all = action.payload.data;
      state.byId = action.payload.data.map((data) => data.id);
      state.isLoading = false;
    },
    update: (state, action) => {
      state.all = state.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    create: (state, action) => {
      state.all.push({ ...action.payload });
      state.byId.push(action.payload.id);
    },
    remove: (state, action) => {
      state.all = state.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.byId = [...state.byId].reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },

    loadItem: (state, action) => {
      state.item.all = action.payload.data;
      state.item.byId = action.payload.data.map((data) => data.id);
      state.item.isLoading = false;
    },
    updateItem: (state, action) => {
      state.item.all = state.item.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    createItem: (state, action) => {
      state.item.all.push({ ...action.payload });
      state.item.byId.push(action.payload.id);
    },
    removeItem: (state, action) => {
      state.item.all = state.item.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.item.byId = [...state.item.byId].reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },
  },
});

export const {
  load,
  create,
  update,
  remove,
  loadItem,
  createItem,
  updateItem,
  removeItem,
} = orderSlice.actions;

export default orderSlice.reducer;
